import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import { setAlert } from "../store/slices/alertSlice";
import {
  departmentsUser,
  searchUsers
} from "../services/api";

import "../styles/incident.css";

const ImmediateAction = ({ data, onChange, disabled = false }) => {

  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [showUsers, setShowUsers] = useState(false);

  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  /* ---------------- FETCH DEPARTMENTS ---------------- */
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const departmentsResponse = await departmentsUser();
        setDepartments(departmentsResponse.data);
      } catch (error) {
        dispatch(setAlert({ message: 'Error fetching data', type: 'danger' }));
      }
    };
    fetchInitialData();
  }, [dispatch]);

  /* ---------------- HANDLE INPUT ---------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    onChange({
      ...data,
      [name]: value,
    });
  };

  /* ---------------- USER SEARCH ---------------- */
  const handleUserSearch = async (e) => {

    const searchText = e.target.value;
    setUserSearch(searchText);

    if (!searchText) {
      setUsers([]);
      setShowUsers(false);
      return;
    }

    try {
      const response = await searchUsers(searchText);
      setUsers(response.data.users);
      setShowUsers(true);
    } catch (error) {
      dispatch(setAlert({ message: "Error loading users", type: "danger" }));
    }
  };

  /* ---------------- SELECT USER ---------------- */
  const selectUser = (user) => {

    // const selectedUsers = data.userIds || [];
    const selectedUsers = data.userObjects || []; // 🔥 keep full objects for UI

    const exists = selectedUsers.find(u => u._id === user._id);

    let updatedUsers;

    if (exists) {
      updatedUsers = selectedUsers.filter(u => u._id !== user._id);
    } else {
      updatedUsers = [...selectedUsers, user];
    }

    // ✅ IMPORTANT FIX: send ONLY IDs to backend
    onChange({
      ...data,
      userIds: updatedUsers.map(u => u._id), // 🔥 FIX
      userObjects: updatedUsers               // 🔥 keep for UI
    });

    setUserSearch("");
    setShowUsers(false);
  };

  /* ---------------- CLOSE DROPDOWN ---------------- */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUsers(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (

    <div className="form-container compact">

      {/* Investigation Details */}
      <div className="form-row">
        <div className="form-control full-width">
          <label>Investigation Details <span className="required-mark">*</span></label>
          <textarea
            name="investigationFindings"
            value={data.investigationFindings || ''}
            onChange={handleInputChange}
            className="form-control large-textarea"
            disabled={disabled}
          />
        </div>
      </div>

      {/* Department */}
      <div className="form-row">
        <div className="form-control">
          <label>Department <span className="required-mark">*</span></label>
          <select
            name="department"
            value={data.department || ''}
            onChange={handleInputChange}
            disabled={disabled}
          >
            <option value="">Select Department</option>
            {departments.map((dept) => (
              <option key={dept._id} value={dept._id}>
                {dept.departmentName}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Priority */}
      <div className="form-row">
        <div className="form-control">
          <label>Priority <span className="required-mark">*</span></label>
          <select
            name="priority"
            value={data.priority || ''}
            onChange={handleInputChange}
            disabled={disabled}
          >
            <option value="">Select Priority</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
        </div>
      </div>

      {/* USER MULTI SELECT */}
      <div className="form-row">
        <div className="form-control" style={{ position: "relative" }} ref={dropdownRef}>

          <label>User (Optional)</label>

          <input
            type="text"
            placeholder="Search user..."
            value={userSearch}
            onChange={handleUserSearch}
            className="form-control"
            disabled={disabled}
          />

          {/* Dropdown */}
          {!disabled && showUsers && users.length > 0 && (
            <div className="dropdown-list">
              {users.map((user) => {
                const isSelected = data.userObjects?.some(u => u._id === user._id);

                return (
                  <div
                    key={user._id}
                    className={`dropdown-item ${isSelected ? 'selected' : ''}`}
                    onClick={() => selectUser(user)}
                  >
                    {user.username}
                    {isSelected && <span style={{ float: 'right' }}>✔</span>}
                  </div>
                );
              })}
            </div>
          )}

          {/* Selected Users */}
          {data.userObjects && data.userObjects.length > 0 && (
            <div className="mt-2">
              {data.userObjects.map((u) => (
                <span
                  key={u._id}
                  className="badge bg-primary me-2"
                  style={{ cursor: disabled ? "default" : "pointer" }}
                  onClick={() => {
                    if (!disabled) selectUser(u);
                  }}
                >
                  {u.username} ✕
                </span>
              ))}
            </div>
          )}

        </div>
      </div>

    </div>
  );
};

export default ImmediateAction;

